// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-framework";
import {
    IWorkflowModuleConfig,
    WorkflowModuleType,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";

export class ProjectModuleCatalog {
    static journalModule: IWorkflowModuleConfig = {
        name: "journal",
        modulePath: PLATFORM.moduleName("modules/workflows/Project/Journal/JournalModule"),
        title: "Journal",
        moduleType: WorkflowModuleType.Project,
        requireClient: false,
        requireSignIn: true,
        canExtend: false,
        isDefaultExtended: true,
        isInadmissible: true,
    };
}
